import { FormikProps } from 'formik';

export interface BotProps {
    shop_id: number;
    bot_name: string;
    bot_full_name: string;
    bot_id: number;
    token: string;
}

export interface MainFormFields {
    name: string;
    title: string;
    placeholder?: string;
    type?: InputType;
}

export interface WelcomeMessageFormFields {
    name: string;
    title: string;
    placeholder: string;
    type: InputType;
}

export interface WelcomeMessageProps {
    shop_id: number;
    welcome_message: string;
    image: File | string;
}

export interface MainFormProps {
    formik: FormikProps<MainFormFields>;
    loading: boolean;
}

export enum InputType {
    input = 'input',
    textArea = 'textArea',
    image = 'image',
}
